import React, { useState } from "react";
import { Link } from "react-router-dom";
import '../styles/BecomeaPartnerPlace.css';


const BecomeaPartnerPlace =()=> {
     const [activeIndex, setActiveIndex] = useState(null);
     const [hoverIndex, setHoverIndex] = useState(null); // ✅ Track hover
    const isMobile = window.innerWidth <= 600;

      const questions = [
        {
question: "What is the Berymo Partnership Program?",
answer:(
<ol className="faq-steps">
<p>
"At Berymo, we strive to differentiate ourselves from a food delivery service. Alternatively, we transport paying customers directly to your front door.
<br /><br />
We ask our partner places to encourage customers to use Berymo Places as their return ride to ensure customers safety and guest satisfaction."
</p>
</ol>
),
},
       
{
question: "How do the Platfrom works?",
answer:(
<ol className="faq-steps">
<p>
"Customers choose your place within the app and schedule a ride. The driver will pick up the customer and transport the customer to your place.
<br /><br />
In order for a customer to claim their free ride, the customer must scan the Berymo Code on their app provided by your place."
</p>
</ol>
),
},{
question: " How will Partnering with Berymo increase my revenue",
answer:(
<ol className="faq-steps">
<p>
 "Your place will be listed on the Berymo Places app. Every customer will be able to see your place, review your menu and specials, as well as, access customer ratings and reviews.
<br /><br />
Once a rider chooses your restaurant, they will request a free ride to your place. They will also have the option to request a return ride.
<br /><br />
Berymo does not charge a service fee if a customer fails to check in or if the customer does not meet the spending requirement."
</p>
</ol>
),
},
         {
          question: "How Much does Berymo charge for customer?",
          answer: "The service fee may change based on your required spending limit and/or your places location. We provide pricing options to fit your interests. Please contact your Berymo Places representative for more information regarding pricing options."
        },
       
      ];
    
      const toggleQuestion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
      };
      return(
        <>
        
          <div className="hero-sec">
        <div className="hero-text">
          <h1>Attract more<br />customers</h1>
          <p>Berymo brings customers right to your door.</p>
          <a href="https://place-sit.berymo.com/#/signup">
          <button className="rideess">Become a Partner place</button>
          </a>
        </div>
        <div className="all-images">
          <img src="/images/siva.jpg" alt="Hero" className="hero-image"/>
        </div>
      </div>
      
      
        
        <div className="berymo-containers">
                <h2>Why partner with Berymo Places</h2>
                <p className="berymo-subtexts">
                  On average, our partner places see a 225% increase on their sales in less than 6 weeks.
                </p>
                <div className="berymo-grids">
                  {[
                    { img: "smile", title: "Generate more incomes", text: "Berymo Places picks up customers and brings them right to your door. Customers dine in the comfort of your place with an inclination to spend more money." },
                    { img: "pie-chart", title: "Customer satisfaction", text: "When partnering with Berymo Places, users can see your place on the app, request a free ride, dine at your restaurant, and request a return ride." },
                    { img: "user", title: "Our responsibilities", text: "Our partner places are mindful of customers drinking and driving. As a partner with Berymo Places, your customers have a safe and return ride." }
                  ].map((item, i) => (
                    <div className="berymo-box" key={i}>
                      <img src={`/images/${item.img}.png`} alt={item.img} className="icon" />
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                      
                 
                    </div>
                    
                  )
                  )}
                </div>
              </div>

               <div className="place-image">
          <img src="/images/places-2.jpg" alt="place" />
        </div>

       {/* FAQ SECTION */}
<div
  style={{
    padding: isMobile ? "40px 15px" : "60px 0",
    backgroundColor: "#fff",
    fontFamily: "Helvetica, Arial, sans-serif",
  }}
>
  <h1
    style={{
      fontSize: isMobile ? "24px" : "26px",
      fontWeight: "bold",
      marginBottom: isMobile ? "25px" : "40px",
      textAlign: "left",
      color: "#000",
      lineHeight: isMobile ? "28px" : "32px",
      maxWidth: "1000px",
      margin: isMobile ? "0 auto" : "0 auto 40px",
    }}
  >
    {isMobile ? (
      <>
        Frequently asked
        <br />
        questions from our
        <br />
        rider
      </>
    ) : (
      "Frequently asked questions from our rider"
    )}
  </h1>

  <div
    style={{
      maxWidth: isMobile ? "100%" : "1000px",
      margin: "0 auto",
    }}
  >
    {questions.map((item, index) => (
      <div
        key={index}
        onClick={() => toggleQuestion(index)}
        onMouseEnter={() => setHoverIndex(index)}
        onMouseLeave={() => setHoverIndex(null)}
        style={{
          borderBottom: "1px solid #e0e0e0",
          padding: isMobile ? "18px 0" : "22px 0",
          cursor: "pointer",
        }}
      >
        {/* Question Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span
            style={{
              fontSize: isMobile ? "16px" : "18px",
              fontWeight: "bold",
              color:
                activeIndex === index || hoverIndex === index
                  ? "#FD5C63"
                  : "#000",
              lineHeight: "22px",
              width: "90%",
            }}
          >
            {item.question}
          </span>

          <span
            style={{
              fontSize: isMobile ? "22px" : "24px",
              fontWeight: 300,
              color:
                activeIndex === index || hoverIndex === index
                  ? "#FD5C63"
                  : "#000",
            }}
          >
            {activeIndex === index ? "×" : "+"}
          </span>
        </div>

        {/* Answer */}
        <div
          style={{
            maxHeight: activeIndex === index ? "400px" : "0px",
            opacity: activeIndex === index ? 1 : 0,
            overflow: "hidden",
            transition: "max-height 0.4s ease, opacity 0.3s ease",
            fontSize: isMobile ? "14px" : "16px",
            lineHeight: "22px",
            color: "#444",
            paddingTop: activeIndex === index ? "10px" : "0px",
            textAlign: "left",
          }}
        >
          {item.answer}
        </div>
      </div>
    ))}
  </div>
</div>
<div
  style={{
    backgroundColor: "#FEF4F5",
    clipPath: "polygon(0 7%, 100% 0, 100% 100%, 0% 100%)",
    padding: isMobile ? "120px 20px 20px" : "120px 20px 50px",
    textAlign: "center",
  }}
>
  <h1
    style={{
      fontSize: isMobile ? "20px" : "25px",
      marginBottom: isMobile ? "10px" : "17px",
      fontWeight: 700,
      lineHeight: isMobile ? "30px" : "42px",
      color: "#000",
    }}
  >
    Get more customers
  </h1>

  <p
    style={{
      fontSize: isMobile ? "14px" : "16px",
      color: "#555",
      lineHeight: isMobile ? "22px" : "26px",
      margin: 0,
    }}
  >
    Berymo is the fastest way to bring more customers to your place
  </p>

  <a
    href="https://place-sit.berymo.com/#/signup"
    style={{ textDecoration: "none" }}
  >
    <button
      style={{
        backgroundColor: "#fd5c63",
        color: "#fff",
        border: "none",
        padding: isMobile ? "1.1rem 1rem" : "1rem 1rem",
        width: isMobile ? "58%" : "240px",
        cursor: "pointer",
        fontWeight: "bold",
        fontSize: isMobile ? "0.7rem" : "0.7rem",
        textTransform: "uppercase",
        textAlign: "center",
        fontFamily: "'Segoe UI', Arial, sans-serif",
        borderRadius: "5px",
        transition: "background-color 0.3s ease, transform 0.2s ease",
        marginTop: isMobile ? "24px" : "30px",
        marginBottom: isMobile ? "40px" : "60px",
      }}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = "#474747";
        e.target.style.transform = "translateY(-2px)";
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = "#fd5c63";
        e.target.style.transform = "scaleX(1)";
      }}
    >
      Become a Partner Place
    </button>
  </a>
</div>

      
        
       </>
      )

}

    export default BecomeaPartnerPlace;